module.exports = __webpack_public_path__ + "static/media/image-003.34874696.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image-003.jpg
// module id = 778
// module chunks = 0